import serivceModule from "../services";

const serviceHelperModeule = angular.module('tdl.services.helpers', ['tdl.services']);

export default serviceHelperModeule;
